import { FileSpreadsheet, FileText, Printer, Globe, Download } from 'lucide-react';
import { generateCustomReport } from '@/lib/ReportGenerator';
import { cn } from '@/lib/cn';

const FORMATS = [
  { key: 'xlsx',  label: 'Excel',  icon: FileSpreadsheet, cls: 'text-emerald-600 hover:bg-emerald-50 dark:hover:bg-emerald-900/20' },
  { key: 'csv',   label: 'CSV',    icon: Download,        cls: 'text-blue-600 hover:bg-blue-50 dark:hover:bg-blue-900/20'          },
  { key: 'pdf',   label: 'PDF',    icon: FileText,        cls: 'text-red-600 hover:bg-red-50 dark:hover:bg-red-900/20'             },
  { key: 'print', label: 'Print',  icon: Printer,         cls: 'text-[var(--text-secondary)] hover:bg-[var(--bg-hover)]'           },
  { key: 'web',   label: 'Web',    icon: Globe,           cls: 'text-purple-600 hover:bg-purple-50 dark:hover:bg-purple-900/20'    },
];

/**
 * Shared export toolbar used by all report pages.
 *
 * @param {Object[]} rows          - Pre-built rows (plain key→value objects)
 * @param {string}   filename      - Base filename without extension
 * @param {string}   title         - Report display title
 * @param {string}   companyName   - Company name shown in report header
 * @param {string}   filterSummary - Human-readable filter description
 * @param {string}   [className]   - Extra wrapper class
 */
export function ReportExportBar({ rows = [], filename, title, companyName = 'AttendX', filterSummary = '', className }) {
  const handleExport = (format) => {
    if (!rows.length) {
      alert('No data to export');
      return;
    }
    generateCustomReport({ rows, title, filename, format, companyName, filterSummary });
  };

  return (
    <div className={cn('flex items-center gap-1 flex-wrap', className)}>
      {FORMATS.map(({ key, label, icon: Icon, cls }) => (
        <button
          key={key}
          onClick={() => handleExport(key)}
          className={cn(
            'flex items-center gap-1.5 h-8 px-3 rounded-lg border border-[var(--border)] text-[12px] font-medium transition-all',
            cls,
          )}>
          <Icon size={13}/>
          {label}
        </button>
      ))}
      <span className="ml-1 text-[11px] text-[var(--text-tertiary)]">{rows.length.toLocaleString()} rows</span>
    </div>
  );
}

export default ReportExportBar;
